<div mat-dialog-title>Warning</div>
<mat-dialog-content>
  {{dialogTitle != '' ? dialogTitle : 'Changes have been made to the Layout but not saved.'}}
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <div *ngIf="!confirmDialog">
        <tyl-button image="save disabled.png" label="Save Layout" [disabled]="true" *ngIf="!enableSave"></tyl-button>
        <tyl-button image="save.png" label="Save Layout" (clickEvent)="saveClick()" *ngIf="enableSave"></tyl-button>
        <tyl-button image="save and new.png" label="Save as New" (clickEvent)="SaveAsNewClick()"></tyl-button>   
    </div>
    <tyl-button image="next arrow.png" [label]="confirmDialog ? 'Continue' : 'Continue without Saving'" (clickEvent)="ContinueWithoutSaveClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
